export const UTM_SETS_PAGE_SIZE = 50;

export const UTM_FIELDS = [
  {
    label: "UTM Source",
    key: "utm_source",
  },
  {
    label: "UTM Medium",
    key: "utm_medium",
  },
  {
    label: "UTM Campaign",
    key: "utm_campaign",
  },
  {
    label: "UTM Content",
    key: "utm_content",
  },
  {
    label: "UTM Term",
    key: "utm_term",
  },
];
